import { render, staticRenderFns } from "./BaseDetailLink.vue?vue&type=template&id=6b65ee41"
import script from "./BaseDetailLink.vue?vue&type=script&lang=js"
export * from "./BaseDetailLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports